import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#customized-trigger-button-of-new-tab" }),
  /*#__PURE__*/_createTextVNode(" Customized trigger button of new tab ")
], -1)
const _hoisted_3 = { class: "rounded border p-10" }
const _hoisted_4 = { style: {"margin-bottom":"20px"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" add tab ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          size: "small",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addTab(_ctx.editableTabsValue)))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.editableTabsValue,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.editableTabsValue = $event)),
        type: "card",
        closable: "",
        onTabRemove: _ctx.removeTab
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.editableTabs, (item) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: item.name,
              label: item.title,
              name: item.name
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.content), 1)
              ]),
              _: 2
            }, 1032, ["label", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onTabRemove"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code7), 1)
        ]),
        _: 1
      })
    ])
  ]))
}